<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <router-link to="/" class="logo" aria-label="천안 휴먼빌 퍼스트시티">
          <span class="logo-img" role="img" aria-label="천안 휴먼빌 퍼스트시티"></span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader'
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: #ffffff;
  border-bottom: 1px solid rgba(3, 35, 48, 0.2);
  transition: background 0.3s ease;
}

.header-inner {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  text-align: center;
}

.logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-decoration: none;
}

.logo-img {
  display: block;
  height: 32px;
  width: 283px;
  max-width: 100%;
  margin: 0 auto;
  /* 로고(logo.png)를 브랜드 컬러 #032330 으로 리컬러 (마스크 기법) */
  background-color: #032330;
  -webkit-mask: url(../assets/logo/logo.png) no-repeat center / contain;
          mask: url(../assets/logo/logo.png) no-repeat center / contain;
}
</style>
